// src/components/sections/PayPalFAQ.tsx
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
  } from "@/components/ui/accordion";
  import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
  import { FAQ_ITEMS } from "@/lib/constants";
  import { schemaData } from "@/lib/seo-config";
  
  const PayPalFAQ = () => {
    return (
      <Card className="bg-white">
        <CardHeader>
          <CardTitle>Häufig gestellte Fragen</CardTitle>
          <p className="text-gray-600 text-base font-normal">
            Antworten auf die wichtigsten Fragen zu PayPal Gebühren und Zahlungsarten.
          </p>
        </CardHeader>
        <CardContent>
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {FAQ_ITEMS.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-gray-50 rounded-lg border p-2 data-[state=open]:bg-white transition-colors"
                >
                  <AccordionTrigger className="text-left hover:no-underline px-4">
                    <span className="text-base font-medium">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4">
                    <div className="text-gray-600 mt-2 text-base leading-relaxed">
                      {faq.answer}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
  
          {/* Add FAQ Schema */}
          <script 
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData.faqs) }}
          />
        </CardContent>
      </Card>
    );
  };
  
  export default PayPalFAQ;